//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TitleSection from '~/components/atoms/Editorial/TitleSection.vue';
import SubtitleSection from '~/components/atoms/Editorial/SubtitleSection.vue';
import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';
import Cta from '~/components/atoms/Cta.vue';
var COLORS = {
  grey: 'primary',
  transparent: 'transparent'
};
export default {
  name: 'FieldSection',
  components: {
    TitleSection,
    SubtitleSection,
    SimpleParagraph,
    Cta
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    backgroundColor() {
      return this.payload.primary.background_color;
    },

    title() {
      return this.payload.primary.title[0] || {};
    },

    titleColor() {
      return this.payload.primary.title_color;
    },

    subtitle() {
      return this.payload.primary.subtitle[0] || {};
    },

    subtitleColor() {
      return this.payload.primary.subtitle_color;
    },

    paragraph() {
      return this.payload.primary.paragraph || [];
    },

    paragraphColor() {
      return this.payload.primary.paragraph_color;
    },

    readMore() {
      return this.payload.primary.read_more === 'Yes';
    },

    spacing() {
      return this.payload.primary.spacing;
    },

    buttons() {
      return this.payload.items.map(item => ({
        props: {
          url: item.button_url.url || '',
          textBtn: item.button_text || '',
          type: COLORS[item.button_color],
          target: item.button_url.target
        },
        tracking: {
          data: {
            event_category: item.button_event_category || '',
            event_action: item.button_event_action || '',
            event_label: item.button_event_label || ''
          }
        }
      }));
    }

  }
};